module.exports = "\r\n    <div class=\"sk-spinner sk-spinner-wandering-cubes pos-loader\">\r\n      <div class=\"sk-cube1\"></div>\r\n      <div class=\"sk-cube2\"></div>\r\n    </div>\r\n"


//////////////////
// WEBPACK FOOTER
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/loader/loader.component.html
// module id = ../../../../../src/app/shared/loader/loader.component.html
// module chunks = main